import React from "react";

import IconButton from "../button/IconButton";
import { projectNavItemHref } from "./projectNavItems";
import useProjectNavItems from "./useProjectNavItems";

export interface ProjectNavLinksProps {
  projectId: string;
  /** ポジション文字列（一覧 API の `current_user_role` 等） */
  position: string;
  /** 納品物なし（total_shots_count === 0）。ホームを出さない */
  noDeliverable: boolean;
  /** アイコンサイズ（px）。既定 18 */
  size?: number;
  /** バナーカラーの上に置くとき true。アイコン色を親から継承する */
  onBanner?: boolean;
}

/**
 * プロジェクトへの導線アイコン列（ホーム / トークルーム / DM / ノート / ライブラリ）。
 * 下部バー（BottomAppBarProject）と同じ基準で出し分け、それぞれ**別タブ**で開く。
 * 横断タスクボードの表・ガントのプロジェクト見出しで使う。
 */
const ProjectNavLinks: React.FC<ProjectNavLinksProps> = ({
  projectId,
  position,
  noDeliverable,
  size = 18,
  onBanner = false,
}) => {
  const items = useProjectNavItems({ projectId, position, noDeliverable });
  if (items.length === 0) return null;

  return (
    <span className="u-row u-items-center u-gap8">
      {items.map((item) => (
        <IconButton
          key={item.id}
          icon={item.icon}
          size={size}
          href={projectNavItemHref(projectId, item)}
          target="_blank"
          ariaLabel={`${item.label}を別タブで開く`}
          color={onBanner ? "inherit" : undefined}
        />
      ))}
    </span>
  );
};

export default ProjectNavLinks;
